import React, { useState } from "react";
import { usePostMarkAsRedeemMutation } from "../../../rtk-query/slices/finance/financeSlice";
import { toast } from "react-toastify";
import ConfirmRedeemModal from "../../bookings/modal/ConfirmRedeemModal";

const BDPriceInfo = ({ bookingDetails, refetchBookingDetails }) => {
  const [showConfirmRedeemModal, setShowConfirmRedeemModal] = useState(false);
  const [postMarkAsRedeem, { isLoading: isPostMarkAsRedeemLoading }] =
    usePostMarkAsRedeemMutation();
  const handleRedeemNow = async (items) => {
    try {
      const bodyData = items
        ?.filter((item) => item.checked)
        .map((item) => item.id); // Extract only the IDs of the selected items
      const response = await postMarkAsRedeem({ order_id: bodyData });
      if (response?.data) {
        toast.success(response?.data?.message, {
          position: "top-center",
          autoClose: 3000,
        });
        refetchBookingDetails();
      }
      if (response?.error) {
        toast.error(response?.error?.data?.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
    } catch (e) {
      toast.error(e?.message, {
        position: "top-center",
        autoClose: 3000,
      });
    } finally {
    }
  };

  return (
    <div className="bd-p-price-info col-lg-7 mt-lg-0 mt-2  bd-white-card-wrapper">
      <div className="d-flex flex-md-nowrap flex-wrap align-items-center mt-1 justify-content-between">
        <p className="bd-p-pax-info-title p-0 m-0 flex-shrink-0">
          Share Price:
        </p>
        <div className="d-flex gap-2 align-items-center flex-wrap justify-content-end w-md-max w-100">
          <h1 className="bd-p-header-title p-0 m-0">
            <span className="bd-p-header-booking-id">
              AED{" "}
              {bookingDetails?.share_amount
                ? bookingDetails?.share_amount
                : bookingDetails?.total_amount}
            </span>
          </h1>
          {bookingDetails?.order_status?.toLowerCase() !== "pending" &&
            bookingDetails?.order_status?.toLowerCase() !== "inprogress" && (
              <button
                onClick={() => {
                  if (
                    bookingDetails?.order_status?.toLowerCase() !== "completed"
                  ) {
                    setShowConfirmRedeemModal(true);
                  }
                }}
                className="bd-p-pax-redeem-now-btn border-0"
              >
                {bookingDetails?.order_status?.toLowerCase() === "completed"
                  ? "Redeemed"
                  : "Redeem Now"}
              </button>
            )}
        </div>
      </div>
      {/* Confirm Redeem Modal */}
      <ConfirmRedeemModal
        show={showConfirmRedeemModal}
        handleClose={() => setShowConfirmRedeemModal(false)}
        listItemsLength={`${bookingDetails?.voucher_number}`}
        isLoading={isPostMarkAsRedeemLoading}
        handleRedeem={async () => {
          await handleRedeemNow([
            { id: bookingDetails?.order_id, checked: true },
          ]);
          setShowConfirmRedeemModal(false);
        }}
      />
    </div>
  );
};

export default BDPriceInfo;
